import React, { Component } from 'react';
import './navbar.css'
import ProductList from '../productList/ProductList';
import Products from '../../../Products';
import AddProduct from '../addProduct/AddProduct';
import BarChart from '../charts/barchart/BarChart';
import ChartList from '../chartList/ChartList';

class AdminNavBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            productList: []
        }
    }

    componentDidMount() {
        this.setState({
            productList: Products
        })
    }


    render() {
        return (
            <div>

                <div className="container">
                    <ul className="nav nav-pills  nav-fill justify-content-center">
                        <li className="nav-item">
                            <a className="nav-link active " href="#Products" data-toggle="tab">View Products</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#AddNew" data-toggle="tab">Add New Product</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#Commentary" data-toggle="tab">Stock Availability</a>
                        </li>
                    </ul>
                    <br /><br />
                    <div className="tab-content">
                        <div role="tabpanel" className="tab-pane active   " id="Products">
                            <ProductList prods={this.state.productList} />
                        </div>
                        <div role="tabpanel2" className="tab-pane " id="AddNew">
                            <AddProduct />
                        </div>
                        <div role="tabpanel3" className="tab-pane " id="Commentary"><ChartList /></div>
                    </div>
                </div>
            </div>




        );
    }
}

export default AdminNavBar;